/* CABERSTON — minimal progressive enhancement.
   Everything here degrades to a working page if JS fails: the nav links are
   real links, the variant picker is a real form, the gallery is real images. */

(function () {
  'use strict';

  /* -- Mobile nav ------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cb-drawer-toggle]');
    if (!toggle) return;

    var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer) return;

    var open = drawer.getAttribute('data-open') === 'true';
    drawer.setAttribute('data-open', String(!open));
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.textContent = open ? toggle.dataset.labelClosed : toggle.dataset.labelOpen;
  });

  /* -- Product gallery --------------------------------------------------
     Thumbnails swap the main image. Uses the <img> that is already in the
     DOM rather than fetching, so there is no flash of empty space.        */
  document.querySelectorAll('[data-cb-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-cb-gallery-main]');
    if (!main) return;

    gallery.querySelectorAll('[data-cb-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.fullSrcset || '';
        main.alt = thumb.dataset.alt || '';

        gallery.querySelectorAll('[data-cb-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  });

  /* -- Variant picker ---------------------------------------------------
     Updates price, availability and the hidden variant id without a reload.
     Variant data is printed as JSON by the section.                       */
  document.querySelectorAll('[data-cb-variants]').forEach(function (root) {
    var dataEl = root.querySelector('[data-cb-variant-data]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // leave the server-rendered state alone
    }

    var form      = root.closest('form') || document.getElementById(root.dataset.cbVariants);
    var idInput   = root.querySelector('[data-cb-variant-id]');
    var priceEl   = root.querySelector('[data-cb-price]');
    var submitEl  = root.querySelector('[data-cb-submit]');
    var restockEl = root.querySelector('[data-cb-restock]');

    root.querySelectorAll('[data-cb-variant-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = variants.find(function (v) {
          return String(v.id) === String(input.value);
        });
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;

        var available = variant.available;

        if (submitEl) {
          submitEl.hidden = !available;
          submitEl.disabled = !available;
        }
        if (restockEl) restockEl.hidden = available;

        // Keep the URL shareable and correct on refresh.
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  });

  /* -- Scroll reveal ---------------------------------------------------- */
  var reveals = document.querySelectorAll('.cb-reveal');
  if (!reveals.length) return;

  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  reveals.forEach(function (el) { observer.observe(el); });
})();
